(function() {
    //console.info("Load CRWRDS")
    angular.module('st')
        .controller('CRewardsTopNavCtrl', [
            '$rootScope', '$scope', '$sce', "$http",
            function ($rootScope, $scope, $sce, $http) {
                //console.info("CRewards ctrl");
                $('.loading-text-spacer').remove();
                var ctrl = this;
                var DEFAULT_TIER = {
                    name: 'basic',
                };

                ctrl.apiCallFinished = false;
                ctrl.hasCard = true;

                ctrl.SignIn = function() {
                    //console.log('signing in');
                    ctrl.signedIn = true;
                };

                ctrl.SignOut = function() {
                    //console.log('signing out');
                    ctrl.signedIn = false;
                };

                ctrl.close = close;

                $scope.init = function() {
                    $http.get("/rpc/membership/account/rewards-status?" + new Date().getTime()
                            /* date added to prevent IE11 from caching this api call (results in wrong info displayed after logging out) */
                        )
                        .then(function (d) {
                            if (d.data.Success == true) {
                                var model = d.data.Data;
                                ctrl.firstName = model.FirstName;
                                ctrl.lastName = model.LastName;
                                if (ctrl.lastName) {
                                    ctrl.lastNameAbbreviation = ctrl.lastName.slice(0,1) + ".";
                                }
                                if (ctrl.firstName) {
                                    try {
                                        var firstestName = ctrl.firstName.split(" ").shift();
                                        ctrl.firstName = firstestName;
                                    } catch (Exception) {
                                        
                                    }
                                }
                                if (!ctrl.firstName) {
                                    ctrl.firstName = "User";
                                }
                                ctrl.points = model.Points;
                                ctrl.signedIn = model.SignedIn;
                                ctrl.qrcodevalue = model.CardNumber;

                                if (ctrl.qrcodevalue) {
                                    ctrl.hasCard = true;
                                } else {
                                    ctrl.hasCard = false;
                                }

                                if (ctrl.signedIn && ctrl.qrcodevalue) {
                                    window.MEMBER_CARD_NUMBER = ctrl.qrcodevalue;
                                    window.MEMBER_ID = model.MemberId;

                                    //get qr code elements (desktop and mobile)
                                    var $qr1 = document.getElementsByClassName("qrcodeclass")[0];
                                    var $qr2 = document.getElementsByClassName("qrcodeclass")[1];
                                    var $qrmodal = document.getElementById("qrcodemodal");

                                    //get if qr code elements (desktop and mobile) already have code generated
                                    var hasDropDownCodeAlready1 = !!$($qr1).find('img').length;
                                    var hasDropDownCodeAlready2 = !!$($qr2).find('img').length;
                                    var hasDropDownCodeAlreadyModal = !!$($qrmodal).find('img').length;

                                    if ($('#qrcode').length && !hasDropDownCodeAlready1) {
                                        var qrcode1 = new QRCode($qr1, {
                                            text: ctrl.qrcodevalue,
                                            colorDark: "#000000",
                                            colorLight: "#ffffff",
                                            correctLevel: QRCode.CorrectLevel.H
                                        });
                                    }
                                    if ($('#qrcode').length && !hasDropDownCodeAlready2) {
                                        var qrcode2 = new QRCode($qr2, {
                                            text: ctrl.qrcodevalue,
                                            colorDark: "#000000",
                                            colorLight: "#ffffff",
                                            correctLevel: QRCode.CorrectLevel.H
                                        });
                                    }
                                    if ($('#qrcodemodal').length && !hasDropDownCodeAlreadyModal) {
                                        var qrcode3 = new QRCode("qrcodemodal", {
                                            text: ctrl.qrcodevalue,
                                            colorDark: "#000000",
                                            colorLight: "#ffffff",
                                            correctLevel: QRCode.CorrectLevel.H
                                        });
                                    }
                                }
                            }

                            $('.loading-text-wrapper').remove();
                            $('.checkout-loading-container').remove();

                            ctrl.apiCallFinished = true;
                            $scope.$applyAsync();
                        });
                };

                $scope.init();
            }
        ]);
})();


//START disable double tap zoom when modal is open
const parentDiv = document.getElementById('qr-code-modal');

document.addEventListener("dblclick", function (event) {
  if (isEventWithinParent(event, parentDiv)) {
    //console.log('Click event occurred within the parent div.');
    event.preventDefault();
  } else {
    //console.log('Click event occurred outside the parent div.');
  }
});

function isEventWithinParent(event, parentElement) {
  let targetElement = event.target;

  while (targetElement) {
    if (targetElement === parentElement) {
      return true;
    }
    targetElement = targetElement.parentNode;
  }
  return false;
}
//END disable double tap zoom when modal is open

//intialize zooming qr code in and out
document.addEventListener('click', function(event) {
    var zoomClasses = ['zoom-1', 'zoom-2', 'zoom-3', 'zoom-4']; //defined in _layout.scss
    const element = document.getElementById('qrcodemodal');
    const elementAdd = document.getElementById('increaseQRModalSize');
    const elementMinus = document.getElementById('decreaseQRModalSize');

    if (element) {        
        const classNames = element.className;

        if (event.target.id === "increaseQRModalSize") {
            //zoom QR code out (increase qr code size)      
            if (!classNames) {
                //largest zoom/size
                return;
            }

            if (classNames.indexOf(zoomClasses[0]) > -1) {
                //cant grow in any more
                elementAdd.classList.add('disabled');
                element.classList.remove(zoomClasses[0]);
            } else if (classNames.indexOf(zoomClasses[1]) > -1) {
                element.classList.replace(zoomClasses[1], zoomClasses[0]);
            } else if (classNames.indexOf(zoomClasses[2]) > -1) {
                element.classList.replace(zoomClasses[2], zoomClasses[1]);
            } else if (classNames.indexOf(zoomClasses[3]) > -1) {
                element.classList.replace(zoomClasses[3], zoomClasses[2]);
                elementMinus.classList.remove('disabled');
            }

        } else if (event.target.id === "decreaseQRModalSize") {
            //zoom QR code in (shrink qr code size)
            if (classNames.indexOf(zoomClasses[3]) > -1) {
                //smallest zoom/shrink
                return;
            }

            if (!classNames) {
                element.classList.add(zoomClasses[0]);
                elementAdd.classList.remove('disabled');
            } else if (classNames.indexOf(zoomClasses[0]) > -1) {
                element.classList.replace(zoomClasses[0], zoomClasses[1]);
            } else if (classNames.indexOf(zoomClasses[1]) > -1) {
                element.classList.replace(zoomClasses[1], zoomClasses[2]);
            } else if (classNames.indexOf(zoomClasses[2]) > -1) {
                element.classList.replace(zoomClasses[2], zoomClasses[3]);
                elementMinus.classList.add('disabled');
            }

        }
    }
});